import React from "react";
import moment from "moment";
import { decimalAdjust } from "../../Global";

export default class TablaPagosComponent extends React.Component {
    render() {
        const { pagos, onProcesar, onEliminar, readOnly, onChangeFields, isLoading, tiposPago } = this.props;

        return (
            <div className="container">
                <div className="card-container">
                    {pagos.map((p, i) => {
                        const isPending = p.Estado === "PENDIENTE" && !readOnly;
                        const cardClass = isPending ? "card-danger" : "";

                        return (
                            <div key={`pago-${p.IdPago}`} className={`card ${cardClass}`} style={{ background: 'transparent', marginBottom: '20px' }}>
                                <div className="card-body ">
                                    <div className=" caja-fondo-blanco-m-2">
                                        <div className="row">
                                            <div className="card-item mt-1 col-12 col-sm-4">
                                                <div className="card-item-label">Fecha</div>
                                                <div className="card-item-value">
                                                    {moment(p.FechaPago).format("DD/MM/YYYY")}
                                                </div>
                                            </div>
                                            <div className="card-item mt-1 col-12 col-sm-4">
                                                <div className="card-item-label">Cuota</div>
                                                <div className="card-item-value">{i + 1}</div>
                                            </div>
                                            <div className="card-item mt-1 col-12 col-sm-4">
                                                <div className="card-item-label">Monto cuota</div>
                                                <div className="card-item-value">
                                                    {parseFloat(p.Monto || 0).toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-item mt-1">
                                            <div className="card-item-label">Total pagado</div>
                                            <div className="card-item-value">
                                                {isPending ? (
                                                    <input
                                                        className="custom-input"
                                                        name="TotalPagado"
                                                        type="number"
                                                        min={0}
                                                        step="0.01"
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => onChangeFields(e, p)}
                                                        value={p.TotalPagado}
                                                    />
                                                ) : (
                                                    parseFloat(p.TotalPagado || 0).toFixed(2)
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-item mt-1 caja-fondo-blanco-m-2">
                                        <div className="card-item-label">Método de pago</div>
                                        <div className="card-item-value">
                                            {isPending ? (
                                                <select
                                                    className="custom-select"
                                                    name="IdTipoPago"
                                                    onChange={(e) => onChangeFields(e, p)}
                                                    value={p.IdTipoPago}
                                                >
                                                    {tiposPago.map((t) => (
                                                        <option key={`opt-pago-${t.IdTipoPago}`} value={t.IdTipoPago}>
                                                            {t.Nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                p.TipoPago
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-item mt-1 caja-fondo-blanco-m-2">
                                        <div className="card-item-label">Núm. Movimiento</div>
                                        <div className="card-item-value">
                                            {isPending ? (
                                                <input
                                                    className="custom-input"
                                                    name="NumeroMovimiento"
                                                    type="text"
                                                    onChange={(e) => onChangeFields(e, p)}
                                                />
                                            ) : (
                                                p.NumeroMovimiento === "null" || p.NumeroMovimiento === null ? "-" : p.NumeroMovimiento
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-item mt-1 caja-fondo-blanco-m-2">
                                        <div className="card-item-label">Total pendiente</div>
                                        <div className="card-item-value">
                                            {parseFloat(p.capital || 0).toFixed(2)}
                                        </div>
                                    </div>
                                    <div className="mt-3 card-footer d-flex justify-content-end align-items-center">
                                        {isPending ? (
                                            <>
                                                {!p.wasFromVenta && (
                                                    <button
                                                        className="custom-button btn-danger mr-2"
                                                        disabled={isLoading}
                                                        onClick={(e) => onEliminar && onEliminar(e, p)}
                                                    >
                                                        Eliminar
                                                    </button>
                                                )}
                                                <button
                                                    className="custom-button btn-verde-mfp"
                                                    disabled={isLoading}
                                                    onClick={(e) => onProcesar && onProcesar(e, p)}
                                                >
                                                    Procesar
                                                </button>
                                            </>
                                        ) : (
                                            !p.wasFromVenta && (
                                                <button
                                                    className="custom-button btn-danger"
                                                    disabled={isLoading}
                                                    onClick={(e) => onEliminar && onEliminar(e, p)}
                                                >
                                                    Eliminar
                                                </button>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}